// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2S6nJ","question":"Question_question__1QCEO","description":"Question_description__2A3ZQ"};